module.exports = __webpack_public_path__ + "static/media/acero-inoxidable-fleje.db6d2abd.jpg";